export default {
  title: 'Populaire items',
  list: {
    empty_list: {
      title: 'Nog geen populaire items.',
    },
    fields: {
      name: 'Naam',
      orders: 'Bestellingen',
      sales: 'Omzet',
    },
  },
};
